import React from 'react'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { font } from '@mobi/component-library/Foundations'
import { RaceProduct } from '@core/Areas/RaceCardFixedOnly'
import type { MetaDataHighlight, SearchResultFobProposition } from '@core/Areas/Search/types'
import { ResultContentListRow } from '@core/Areas/Search/Components/Common/ResultContentListRow'
import { HighlightDisplay } from '@core/Areas/Search/Components/Common/HighlightDisplay'
import { LocationTime } from '../Common/LocationTime'

export const FobPropositionResult: React.FC<{
  searchResult: SearchResultFobProposition
  highlights: MetaDataHighlight
}> = ({ searchResult, highlights }) => {
  const { fobProposition } = searchResult
  const isFooOrFff = [RaceProduct.FixedOddsOnly, RaceProduct.FutureFinalField].includes(
    fobProposition.fobEvent.productCode as RaceProduct
  )

  const advertisedStartTime = fobProposition.isStartTimeRelevant
    ? fobProposition.fobEvent.startTime
    : undefined

  const prices = fobProposition.price

  return (
    <ResultContentListRow
      testId='SearchResultFobProposition'
      topContent={
        <LocationTime
          locationName={fobProposition.fobEvent.raceCourse}
          raceNumber={fobProposition.fobEvent.number}
          advertisedStartTime={advertisedStartTime}
          code={fobProposition.fobEvent.contestType}
          status={fobProposition.result ?? fobProposition.status}
          highlightKey='fobProposition.fobEvent.raceCourse'
          highlights={highlights}
        />
      }
      primaryText={
        <>
          {fobProposition.number}
          {' - '}
          <HighlightDisplay
            displayText={fobProposition.name}
            highlightKey='fobProposition.name'
            highlights={searchResult.metadata.highlights}
          />
        </>
      }
      secondaryText={
        isFooOrFff ? null : (
          <HighlightDisplay
            displayText={fobProposition.fobEvent.name}
            highlightKey='fobProposition.fobEvent.name'
            highlights={searchResult.metadata.highlights}
          />
        )
      }
      rightContent={
        prices &&
        (prices.winPrice || prices.placePrice) && (
          <Flex flexDirection='column' alignItems='flex-end'>
            <span style={{ fontWeight: font.weight.medium }}>
              {prices.winPrice?.toFixed(2) ?? '-'}
            </span>
            <span style={{ fontWeight: font.weight.medium }}>
              {prices.placePrice?.toFixed(2) ?? '-'}
            </span>
          </Flex>
        )
      }
    />
  )
}
